<template>
  <div
    class="gradient-bg py-5"
    data-aos="fade-up"
    data-aos-duration="800"
    data-aos-offset="-500"
  >
    <b-container>
      <b-row>
        <b-col sm="12" md="6" class="plate-con">
          <img src="../assets/svgs/plate1.svg" alt="" class="plate mt-0 pt-0	" />
        </b-col>
        <b-col sm="12" md="6">
          <div
            class="rainbow-box mb-5 mt-5 mt-md-0 justify-content-center align-items-center"
            @click="showAbout"
          >
            <p class="white-text mb-0">Go on, click!</p>
          </div>
          <div class="rainbow-click position-relative" @click="hideAbout">
            <div class="rainbow-rect rec-1"></div>
            <div class="rainbow-rect rec-2"></div>
            <div class="rainbow-rect rec-3"></div>
            <div class="rec-profile pale-bg d-flex align-items-center">
              <img
                src="https://res.cloudinary.com/ajiva/image/upload/v1581695376/portfolio/David-Aji-website-image-2.jpg"
                alt=""
                class="ml-2 mr-3"
              />
              <h3>I'm {{ myest }}!</h3>
            </div>
          </div>
          <p class="max-width-p p pl-4">
            Learning! I'm always learning. That's been the bedrock of my career
            so far. I'm an addict for information and knowledge and this has
            helped me to grow. Of course I'm always willing to dish out this
            knowledge too, There's no better way to get clearer understanding
            than by teaching.
            <br /><b>Ah Yes! I'm available for Hire.</b>
          </p>
          <div class="work-box mr-5">
            <div>
              <List header="qualifications" :items="qualifications"></List>
              <List header="work history" :items="work"></List>
              <div>
                <!-- <p class="thick-text red-text mb-0 pl-4 b-bottom">
								STACKS
						</p> -->
                <div class="d-flex flex-wrap py-3 px-4">
                  <img
                    src="../assets/svgs/vue-logo.svg"
                    alt="Vue Logo"
                    class="stack-logo mx-3 my-2"
                  />
                  <img
                    src="../assets/svgs/react-logo.svg"
                    alt="React Logo"
                    class="stack-logo mx-3 my-2"
                  />
                  <!-- <img
										src="https://res.cloudinary.com/ajiva/image/upload/v1590662531/portfolio/Sass_Logo_-_Seal_Color.png"
										alt="Sass Logo"
										class="stack-logo ml-3"
									/> -->
                  <img
                    src="../assets/svgs/sasslogo.png"
                    alt="Sass Logo"
                    class="stack-logo mx-3 my-2"
                  />
                  <img
                    src="../assets/svgs/svelte.png"
                    alt="Svelte Logo"
                    class="stack-logo mx-3 my-2"
                  />
                  <img
                    src="../assets/svgs/nuxt.png"
                    alt="Nuxt Logo"
                    class="stack-logo mx-3 my-2"
                  />
                  <img
                    src="../assets/svgs/tailwindcss.png"
                    alt="TailwindCSS Logo"
                    class="stack-logo mx-3 my-2"
                  />
                  <img
                    src="../assets/svgs/firebase.png"
                    alt="Firebase Logo"
                    class="stack-logo mx-3 my-2"
                  />
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { BContainer, BRow, BCol } from "bootstrap-vue";
import List from "../components/Lists";
export default {
  components: {
    BContainer,
    BRow,
    BCol,
    List
  },
  data() {
    return {
      qualifications: [
        {
          date: `2020`,
          content: `BSc. Computer Science`
        },
        {
          date: `2017`,
          content: `Andela Front End Web Development`
        }
      ],
      work: [
				 {
          date: `2021 - Present`,
          content: `Casava MicroInsurance`
        },
        {
          date: `2020 - Nov 2021`,
          content: `Crenet TechLabs`
        },
        {
          date: `2020 - March 2021`,
          content: `LogRocket - Technical Writer`
        },
        {
          date: `2018 - Aug 2020`,
          content: `Codekago Interactive`
        },
        {
          date: `2017, 2019`,
          content: `Hotels.ng Internship`
        },
        {
          date: `2017`,
          content: `Freelance`
        }
      ],
      myest: ""
    };
  },
  methods: {
    showAbout() {
      const rainbow = document.querySelector(".rainbow-box");
      const rainbowAbout = document.querySelector(".rainbow-click");
      const profile = document.querySelector(".rec-profile");
      const rec2 = document.querySelector(".rec-2");
      const rec3 = document.querySelector(".rec-3");
      rainbow.style.display = "none";
      rainbowAbout.style.display = "block";
      profile.classList.remove("close-rec");
      rec2.classList.remove("close-rec");
      rec3.classList.remove("close-rec");
      let est = [
        "Incredible",
        "The Man",
        "Extraordinary",
        "Fun",
        "Awesome",
        "Amazing",
        "Creative",
        "a team player",
        "Productive",
        "a nerd-ish?!",
        "a learner"
      ];
      let i = Math.floor(Math.random() * est.length);
      this.myest = est[i];
    },
    hideAbout() {
      const rainbow = document.querySelector(".rainbow-box");
      const rainbowAbout = document.querySelector(".rainbow-click");
      const profile = document.querySelector(".rec-profile");
      const rec2 = document.querySelector(".rec-2");
      const rec3 = document.querySelector(".rec-3");
      rainbow.style.display = "flex";
      profile.classList.add("close-rec");
      rec2.classList.add("close-rec");
      rec3.classList.add("close-rec");
      rainbowAbout.style.display = "none";
    }
  },
  mounted() {
    // Init
    var container = document.querySelector(".plate-con"),
      inner = document.querySelector(".plate");

    // Mouse
    var mouse = {
      _x: 0,
      _y: 0,
      x: 0,
      y: 0,
      updatePosition: function(event) {
        var e = event || window.event;
        this.x = e.clientX - this._x;
        this.y = (e.clientY - this._y) * -1;
      },
      setOrigin: function(e) {
        this._x = e.offsetLeft + Math.floor(e.offsetWidth / 2);
        this._y = e.offsetTop + Math.floor(e.offsetHeight / 2);
      },
      show: function() {
        return "(" + this.x + ", " + this.y + ")";
      }
    };

    // Track the mouse position relative to the center of the container.
    mouse.setOrigin(container);

    //----------------------------------------------------

    var counter = 0;
    var refreshRate = 10;
    var isTimeToUpdate = function() {
      return counter++ % refreshRate === 0;
    };

    //----------------------------------------------------

    var onMouseEnterHandler = function(event) {
      update(event);
    };

    var onMouseLeaveHandler = function() {
      inner.style = "";
    };

    var onMouseMoveHandler = function(event) {
      if (isTimeToUpdate()) {
        update(event);
      }
    };

    //----------------------------------------------------

    var update = function(event) {
      mouse.updatePosition(event);
      updateTransformStyle(
        (mouse.y / inner.offsetHeight / 2).toFixed(2),
        (mouse.x / inner.offsetWidth / 2).toFixed(2)
      );
    };

    var updateTransformStyle = function(x, y) {
      var style = "rotateX(" + x + "deg) rotateY(" + y + "deg)";
      inner.style.transform = style;
      inner.style.webkitTransform = style;
      inner.style.mozTranform = style;
      inner.style.msTransform = style;
      inner.style.oTransform = style;
    };

    //--------------------------------------------------------

    container.onmousemove = onMouseMoveHandler;
    container.onmouseleave = onMouseLeaveHandler;
    container.onmouseenter = onMouseEnterHandler;
  }
};
</script>

<style>
.plate-con {
  perspective: 30px;
}
.plate {
  width: 100%;
  height: auto;
  object-fit: contain;
  transition: transform 0.5s;
}
.plate:hover {
  -webkit-box-shadow: -4px 52px 77px -21px rgba(113, 32, 28, 0.2);
  -moz-box-shadow: -4px 52px 77px -21px rgba(113, 32, 28, 0.2);
  box-shadow: -4px 52px 77px -21px rgba(113, 32, 28, 0.2);
  transition: all 0.1s linear;
}
/* .rainbow-box:hover{
	display: none;
} */
.close-rainbow {
  top: 0;
  left: 0;
  transition: all 0.5s ease-out;
}
.rainbow-click {
  display: none;
  transition: all 2s ease-in;
  height: 150px;
}
/* .rainbow-box:hover .rainbow-click{
	display: block;
} */
.rec-profile {
  height: 100px;
  width: 400px;
  position: absolute;
  top: -30px;
  left: 30px;
  animation: open-rec-profile 0.5s ease-in-out,
    float1 5s ease 0.1s infinite alternate-reverse;
}
@keyframes open-rec-profile {
  from {
    top: 0;
    left: 0;
  }
  top {
    top: -30px;
    left: 30px;
  }
}
.rec-profile img {
  width: 80px;
  height: 80px;
}

.rainbow-rect {
  background-image: repeating-linear-gradient(
    180deg,
    #d0400f,
    #957bd9,
    #f3a3a0,
    #b3e191
  );
  height: 100px;
  width: 400px;
}
.rec-1 {
  position: absolute;
  top: 0;
  left: 0;
  animation: float4 5s ease 0.1s infinite alternate-reverse;
}
.rec-2 {
  position: absolute;
  top: -10px;
  left: 10px;
  animation: open-rec-2 0.5s ease-in-out,
    float3 5s ease 0.1s infinite alternate-reverse;
}
@keyframes open-rec-2 {
  from {
    top: 0;
    left: 0;
  }
  top {
    top: -10px;
    left: 10px;
  }
}
.rec-3 {
  position: absolute;
  top: -20px;
  left: 20px;
  animation: open-rec-3 0.5s ease-in-out,
    float2 5s ease 0.1s infinite alternate-reverse;
}
@keyframes open-rec-3 {
  from {
    top: 0;
    left: 0;
  }
  top {
    top: -20px;
    left: 20px;
  }
}
.rainbow-box {
  height: 100px;
  width: 100px;
  background-image: repeating-linear-gradient(
    180deg,
    #d0400f,
    #957bd9,
    #f3a3a0,
    #b3e191
  );
}
.rainbow-box p {
  opacity: 0;
}
.rainbow-box:hover p {
  opacity: 1;
  transition: all 0.2s ease;
  cursor: pointer;
}
.rainbow-box:hover {
  display: flex;
  width: 400px;
  transition: width 0.3s ease-in;
  animation: rainbow-rotate 3s ease-in-out 0.1s infinite alternate;
}
@keyframes rainbow-rotate {
  /* 0%{
			background-image: repeating-linear-gradient(180deg, #d0400f, #957bd9, #f3a3a0, #b3e191, #2fbaca, #5f759d);
	} */
  0% {
    background-image: repeating-linear-gradient(
      180deg,
      #957bd9,
      #f3a3a0,
      #b3e191,
      #2fbaca,
      #5f759d,
      #d0400f
    );
  }
  25% {
    background-image: repeating-linear-gradient(
      180deg,
      #f3a3a0,
      #b3e191,
      #2fbaca,
      #5f759d,
      #d0400f,
      #957bd9
    );
  }
  50% {
    background-image: repeating-linear-gradient(
      180deg,
      #b3e191,
      #2fbaca,
      #5f759d,
      #d0400f,
      #957bd9,
      #f3a3a0
    );
  }
  75% {
    background-image: repeating-linear-gradient(
      180deg,
      #2fbaca,
      #5f759d,
      #d0400f,
      #957bd9,
      #f3a3a0,
      #b3e191
    );
  }
  100% {
    background-image: repeating-linear-gradient(
      180deg,
      #5f759d,
      #d0400f,
      #957bd9,
      #f3a3a0,
      #b3e191,
      #2fbaca
    );
  }
}
.work-box {
  border: 1px solid #71201c;
}
.b-bottom {
  border-bottom: 1px solid #71201c;
}
.stack-logo {
  width: 50px;
}

@keyframes float1 {
  0% {
    top: -40px;
    left: 40px;
  }
  25% {
    top: -20px;
    left: 70px;
  }
  50% {
    top: -15px;
    left: 50px;
  }
  75% {
    top: -20px;
    left: 30px;
  }
  100% {
    top: -30px;
    left: 30px;
  }
}

@keyframes float2 {
  0% {
    top: -30px;
    left: 30px;
  }
  25% {
    top: -10px;
    left: 60px;
  }
  50% {
    top: -25px;
    left: 40px;
  }
  75% {
    top: -10px;
    left: 20px;
  }
  100% {
    top: -20px;
    left: 20px;
  }
}

@keyframes float3 {
  0% {
    top: -20px;
    left: 20px;
  }
  25% {
    top: 0px;
    left: 50px;
  }
  50% {
    top: -35px;
    left: 30px;
  }
  75% {
    top: 0px;
    left: 10px;
  }
  100% {
    top: -10px;
    left: 10px;
  }
}

@keyframes float4 {
  0% {
    top: -10px;
    left: 10px;
  }
  25% {
    top: 10px;
    left: 40px;
  }
  50% {
    top: -45px;
    left: 20px;
  }
  75% {
    top: 10px;
    left: 0px;
  }
  100% {
    top: 0px;
    left: 0px;
  }
}

@media only screen and (max-width: 768px) {
  .rainbow-rect,
  .rec-profile {
    width: 300px;
  }
}

@media only screen and (max-width: 999px) {
  .work-box {
    width: 100%;
  }
}
</style>
